module.exports = __webpack_public_path__ + "img/menu_notification.577e5619.svg";